import { render } from "./TrashedMessage.vue?vue&type=template&id=858fb6e8"
import script from "./TrashedMessage.vue?vue&type=script&lang=js"
export * from "./TrashedMessage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Shared/TrashedMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "858fb6e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('858fb6e8', __exports__)) {
    console.log('reload')
    api.reload('858fb6e8', __exports__)
  }
  
  module.hot.accept("./TrashedMessage.vue?vue&type=template&id=858fb6e8", () => {
    console.log('re-render')
    api.rerender('858fb6e8', render)
  })

}


export default __exports__